<div class="pull-left text-muted">
  <i class="fa fa-calendar" aria-hidden="true"></i> {{history.data | date:'dd \'de\' MMMM'}}
</div>
<div class="pull-right text-muted">
  <a ng-click = "activeHistoryApplications()" ng-if="permissions.pulverizacao.canRead">
    <i class="icon-updated" aria-hidden="true"></i> Histórico
  </a>
</div>
<div class="clearfix"></div>

<div class="title text-center">
  <h2>
    <strong>PULVERIZAÇÃO</strong>
  </h2>
</div>

<div class="aplicacao">
  <div class="row no-margin height-100">
    <div class="col-xs-12 no-padding">
      <div class="list-group">
        <ul class="nav nav-tabs nav-tab-panel">
          <li ng-class="{active: aplicacao.currentTab == 0}">
            <a ng-click="clickTab(0)"><strong>Dados</strong></a>
          </li>
          <li ng-class="{active: aplicacao.currentTab == 1}">
            <a ng-click="clickTab(1)"><strong>Recomendação</strong></a>
          </li>
        </ul>

        <div class="tab-content">
          <div class="tab-pane fade in" ng-class="{active: aplicacao.currentTab == 0}">
            <div ng-repeat="aplicacao in aplicacoes">
              <span ng-show="$index">&nbsp;</span>
              <div class="list-group-item no-padding">
                <!-- aplicador -->
                <br>
                <p>
                  <strong>Código</strong> <span class="pull-right">{{::aplicacao.id}}</span>
                </p>
                <p>
                  <strong>Operador</strong> <span class="pull-right">{{::aplicacao.atributo.operador.nome | capitalize}}</span>
                </p>
                <p>
                  <strong>Máquina</strong>
                  <span class="pull-right" ng-if="aplicacao.maquinaDescricao.length <= 25">{{::aplicacao.maquinaDescricao}}</span>
                  <span class="pull-right" ng-if="aplicacao.maquinaDescricao.length > 25"
                        uib-tooltip="{{::aplicacao.maquinaDescricao}}" tooltip-placement="left" tooltip-append-to-body="true">
                    {{::aplicacao.maquinaDescricao | characters: 25}}
                  </span>
                </p>
                <p>
                  <strong>Capacidade Tanque</strong>
                  <span class="pull-right">{{::aplicacao.atributo.capacidade_tanque | number:2}}</span>
                </p>

                <p> <strong>Área aplicada</strong> <span class="pull-right">{{::aplicacao.area || 0 | number:2}} ha </span></p>
                <!-- fim aplicador -->
                <!-- Table produtos -->
                <p class="list-group-item-text">
                  <table class="table no-padding">
                    <thead>
                      <tr>
                        <th class="no-padding-left">Descrição</th>
                        <th class="text-right">Dose</th>
                        <th class="text-right">Quantidade</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr ng-repeat="item in aplicacao.itens track by $index">
                        <td class="no-padding-left vertical-middle">
                          {{::item.descricao}}
                          <span ng-if="item.qt_area != aplicacao.area">({{::item.qt_area | number:2}} ha)</span>
                        </td>
                        <td class="text-right">{{::item.qt_dose | number:2}} {{::item.unidade.abreviatura}}/ha</td>
                        <td class="text-right">{{::item.qt_total | number:2}} {{::item.unidade.abreviatura}}</td>
                      </tr>
                    </tbody>
                  </table>
                </p>
                <!-- fim table produtos -->

                <p class="list-group-item-text" ng-show="aplicacao.atributo">
                  <!-- paradas -->
                  <div ng-show="aplicacao.atributo.paradas.length > 0">
                    <br>
                      <div class="title text-center">
                        <h2>
                          <strong>Paradas</strong>
                        </h2>
                      </div>
                    <br>
                    <table class="table no-padding">
                      <thead>
                        <tr class="no-padding">
                          <th class="text-center ">Início</th>
                          <th class="text-center">Fim</th>
                          <th class="text-right">Tempo Parado</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr ng-repeat="parada in aplicacao.atributo.paradas | orderBy: 'inicio' track by $index">
                          <td class="text-center">{{::parada.inicio | date:'HH:mm:ss'}}</td>
                          <td class="text-center">{{::parada.termino | date:'HH:mm:ss'}}</td>
                          <td class="text-right">{{getDurationFromSeconds(parada.tempo_parado)}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- fim paradas -->
                  <!-- demais dados aplicação -->
                  <span class="text-muted">
                    <strong ng-hide="aplicacao.atributo.acompanhamento == 'S'">Sem acompanhamento<br></strong>
                    Iniciada em {{aplicacao.atributo.iniciado_em | date:'HH:mm:ss'}}
                    <br>
                    Encerrada em {{aplicacao.atributo.encerrado_em | date:'HH:mm:ss'}}
                    <br>
                    Tempo Decorrido: <strong>{{getDurationFromSeconds(aplicacao.atributo.tempo_decorrido)}}</strong>
                    <br>
                    <span ng-show="aplicacao.atributo.temperatura_inicial">
                      Temperatura Inicial: {{ aplicacao.atributo.temperatura_inicial | number:0 }} °C<br>
                    </span>

                    <span ng-show="aplicacao.atributo.temperatura_final">
                      Temperatura Final: {{ aplicacao.atributo.temperatura_final | number:0  }} °C<br>
                    </span>

                    <span ng-show="aplicacao.atributo.umidade_inicial">
                      Umidade Inicial: {{ aplicacao.atributo.umidade_inicial | number:0  }}%<br>
                    </span>

                    <span ng-show="aplicacao.atributo.umidade_final">
                      Umidade Final: {{ aplicacao.atributo.umidade_final | number:0  }}%<br>
                    </span>

                    <p ng-show="aplicacao.atributo.horas_sem_chuva">
                      <strong>Horas sem chuva: </strong>{{aplicacao.atributo.horas_sem_chuva | number:0}}
                    </p>
                  </span>
                </p>

                <p class="list-group-item-text" ng-show="aplicacao.obs">Observação: {{aplicacao.obs}}</p>
                <!-- fim demais dados aplicação -->
              </div>
            </div>
          </div>
        </div>

        <!--recomendacao -->
        <div class="tab-content">
          <div class="tab-pane fade in" ng-class="{active: aplicacao.currentTab == 1}">
            <div ng-repeat="recomendacao in recomendacoes">
              <hr ng-show="$index">

              <p ng-hide="recomendacao.id">
                <br>Sem recomendação para aplicação de código <strong>{{recomendacao.aplicacaoId}}</strong>
              </p>

              <div ng-show="recomendacao.id">
                <br ng-hide="$index">
                Recomendação para aplicação <strong>{{recomendacao.aplicacaoId}}</strong>
                <ng-include ng-show="recomendacao.id" src="'views/painel_propriedade/recomendacao/_resumo_recomendacao.html'"></ng-include>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
